import { useEffect, useRef, useState } from 'react'

import { Grid, Paper } from '@material-ui/core'
import ConfirmationModal from '../../components/ConfirmationModal'
import DepartmentOptionsFlow from '../../components/DepartmentOptionsFlow'
import ProtectedRoute from '../../components/ProtectedRoute'
import toastError from '../../errors/toastError'
import api from '../../services/api'
import { useStyles } from './styles'

export const DepartmentsFlow = ({ queueId }) => {
  const classes = useStyles()

  // const { queueId } = useParams()
  // const { user } = useContext(AuthContext)

  const [attachment, setAttachment] = useState(null)
  const attachmentFile = useRef(null)
  const [confirmationOpen, setConfirmationOpen] = useState(false)
  const [, setOptions] = useState([])

  const initialState = {
    name: '',
    description: '',
    greetingMessage: '',
    mediaPath: null,
    mediaName: null
  }
  const [queue, setQueue] = useState(initialState)

  useEffect(() => {
    const fetchDepartmentData = async () => {
      if (!queueId) {
        setQueue(initialState)
        setOptions([]) // Reseta as opções
        return
      }

      try {
        const { data: queueData } = await api.get(`/queue/${queueId}`)
        setQueue(queueData)

        const { data: optionsData } = await api.get(`/queue-options`, {
          params: { queueId, parentId: -1 }
        })

        // Lógica para construir a árvore de opções (recursiva)
        const buildOptionTree = async list => {
          for (const option of list) {
            const { data: childrenData } = await api.get(`/queue-options`, {
              params: { queueId, parentId: option.id }
            })
            option.children = await buildOptionTree(childrenData)
          }
          return list
        }

        const optionTree = await buildOptionTree(optionsData)
        setOptions(optionTree)
      } catch (err) {
        toastError(err)
      }
    }
    fetchDepartmentData()
  }, [queueId])

  const deleteMedia = async () => {
    if (attachment) {
      setAttachment(null)
      attachmentFile.current.value = null
    }
    if (queue.mediaPath) {
      await api.delete(`/queue/${queue.id}/media-upload`)
      setQueue(prev => ({ ...prev, mediaPath: null, mediaName: null }))
    }
    setConfirmationOpen(false)
  }

  return (
    <ProtectedRoute
      requiredRoles={['super', 'admin', 'departamentos']}
      fallbackPath="/tickets"
    >
      <Paper className={classes.mainPaper}>
        <ConfirmationModal
          title="Deletar Anexo"
          open={confirmationOpen}
          onClose={() => setConfirmationOpen(false)}
          onConfirm={deleteMedia}
        >
          Tem certeza de que deseja excluir o anexo? Esta ação não pode ser
          desfeita.
        </ConfirmationModal>

        <Grid container className={classes.container}>
          <DepartmentOptionsFlow queueId={queueId} />
        </Grid>
      </Paper>
    </ProtectedRoute>
  )
}
